import React from "react";
import { LANGS } from "@/i18n";

const LanguageToggle = ({ lang, onChange }) => {
  return (
    <div
      className="inline-flex items-center rounded-full border border-border bg-white p-1 shadow-sm"
      role="group"
      aria-label="Language toggle"
      data-testid="language-toggle"
    >
      {LANGS.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            onClick={() => onChange(l.code)}
            data-testid={`language-toggle-${l.code}`}
            className={`min-h-[40px] px-3 rounded-full text-sm font-semibold transition-all ${
              active
                ? "bg-terracotta text-white shadow-sm"
                : "text-muted-foreground hover:text-terracotta"
            }`}
            aria-pressed={active}
          >
            <span className="mr-1 text-base">{l.short}</span>
            <span>{l.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default LanguageToggle;
